function formatMeridiemTime(value: string | null | undefined) {
  if (!value) return "-";

  const [hourText, minuteText] = value.split(":");
  const hour = Number(hourText);
  const minute = Number(minuteText);
  if (!Number.isFinite(hour) || !Number.isFinite(minute)) return value;

  const period = hour >= 12 ? "오후" : "오전";
  const hour12 = hour % 12 === 0 ? 12 : hour % 12;

  return `${period} ${hour12.toString().padStart(2, "0")}:${minute
    .toString()
    .padStart(2, "0")}`;
}

export function TimeRangeCell({
  type,
  startTime,
  endTime,
}: {
  readonly type: string;
  readonly startTime: string | null;
  readonly endTime: string | null;
}) {
  return (
    <div className="flex min-w-0 items-center justify-center">
      <div className="grid min-w-0 max-w-full flex-1 grid-cols-[minmax(0,1fr)_auto_minmax(0,1fr)] items-center gap-x-1">
        {type !== "근무" ? (
          <div className="flex items-center justify-center whitespace-nowrap text-center">
            -
          </div>
        ) : (
          <div className="conf_shift_time flex items-center justify-center whitespace-nowrap text-center">
            {formatMeridiemTime(startTime)}
          </div>
        )}
        <span className="text-center">~</span>
        {type !== "근무" ? (
          <div className="flex items-center justify-center whitespace-nowrap text-center">
            -
          </div>
        ) : (
          <div className="conf_shift_time flex items-center justify-center whitespace-nowrap text-center">
            {formatMeridiemTime(endTime)}
          </div>
        )}
      </div>
    </div>
  );
}

export function StatusBadge({
  checked,
  label,
  activeText = "반영",
  inactiveText = "미반영",
  unavailable = false,
}: {
  readonly checked: boolean;
  readonly label: string;
  readonly activeText?: string;
  readonly inactiveText?: string;
  readonly unavailable?: boolean;
}) {
  if (unavailable) {
    return (
      <span
        role="status"
        aria-label={`${label} 조건 미해당`}
        title="OFF 대체 조건에 해당하지 않습니다."
        className="inline-flex min-w-12 items-center justify-center text-sm font-medium text-[#98A2B3]"
      >
        -
      </span>
    );
  }

  return (
    <span
      role="status"
      aria-label={label}
      className={
        checked
          ? "inline-flex h-6 min-w-12 items-center justify-center rounded-md border border-[#B7D4FF] bg-[#EFF6FF] px-2 text-xs font-semibold text-[#0E59C6]"
          : "inline-flex h-6 min-w-12 items-center justify-center rounded-md border border-[#E4E7EC] bg-white px-2 text-xs font-semibold text-[#98A2B3]"
      }
    >
      {checked ? activeText : inactiveText}
    </span>
  );
}
